import type { DetectedElement, Product, ProductMatch } from "./types";

const hasAny = (left: string[], right: string[]) => left.some((value) => right.includes(value));

export function scoreProduct(
  element: DetectedElement,
  product: Product,
  budgetMaxCents?: number,
): ProductMatch | null {
  if (!product.active || element.category !== product.category) return null;

  let score = 35;
  const explanation = ["Ista kategorija"];

  if (hasAny(element.colourTags, product.colourTags)) {
    score += 15;
    explanation.push("Slična boja");
  }
  if (hasAny(element.styleTags, product.styleTags)) {
    score += 15;
    explanation.push("Odgovara stilu");
  }
  if (hasAny(element.featureTags, product.featureTags)) {
    score += 10;
    explanation.push("Slične značajke");
  }
  if (element.widthCm && product.widthCm) {
    if (product.widthCm <= element.widthCm) {
      score += 10;
      explanation.push("Stane u zadanu širinu");
    } else {
      score -= 30;
      explanation.push("Šire od zadane mjere");
    }
  }
  if (budgetMaxCents) {
    if (product.priceCents <= budgetMaxCents) {
      score += 10;
      explanation.push("Unutar budžeta");
    } else if (product.priceCents > budgetMaxCents * 1.2) {
      score -= 25;
      explanation.push("Više od 20% iznad budžeta");
    }
  }
  if (hasAny(element.materialTags, product.materialTags)) {
    score += 5;
    explanation.push("Sličan materijal");
  }

  return {
    product,
    score,
    level: score >= 75 ? "Vrlo slično" : score >= 55 ? "Slično" : "Inspirirano",
    explanation,
  };
}

export function matchProducts(
  element: DetectedElement,
  catalog: Product[],
  budgetMaxCents?: number,
): ProductMatch[] {
  return catalog
    .map((product) => scoreProduct(element, product, budgetMaxCents))
    .filter((match): match is ProductMatch => match !== null)
    .sort((a, b) => b.score - a.score || a.product.priceCents - b.product.priceCents);
}
